import { ProductTypeConfig, DEFAULT_SECTIONS } from '../types';

/**
 * 2100 - Warrant
 */
export const config2100: ProductTypeConfig = {
  code: '2100',
  name: 'Warrant',
  sections: {
    ...DEFAULT_SECTIONS,
    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: false,
        premium: true,
        quotationType: true,
        strike: true,
        basketOptionType: true,
        settlementType: true,
      },
    },
    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: false,
    },
    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        ...DEFAULT_SECTIONS.underlyings.props,
        barrierLevel: false,
        barrierDistance: false,
      },
    },
    couponDetails: {
        ...DEFAULT_SECTIONS.couponDetails,
        enabled: false,
    },
  },
};
